import { Component, HostListener, Input, inject } from '@angular/core';
import {ProjectReferenceDetailResponse} from '../../models/project-reference-detail.response';
import {Observable} from 'rxjs';
import {PrintDataService} from '../../services/print-data.service';
import {PrintConfig} from '../../models/print-data';
import {ProjectAttribute} from '../../models/project-attribute';

@Component({
    selector: 'app-project-reference-print',
    templateUrl: './project-reference-print.component.html',
    standalone: false
})
export class ProjectReferencePrintComponent {
    private printDataLoadingService = inject(PrintDataService);

    _projectReference: ProjectReferenceDetailResponse | undefined;
    photoGridAreas = ['a', 'b', 'c', 'd', 'e'];

    @Input()
    set projectReference(response: ProjectReferenceDetailResponse) {
        this._projectReference = {...response};
    }

    filteredPrintData$: Observable<PrintConfig | null> = this.printDataLoadingService.printConfig$;

    getSelectedValue(attribute: ProjectAttribute) {
        return attribute.values.find(value => value.id === attribute.selectedValueId);
    }
}
